import { lazyWithRetry as lazy } from './lazyWithRetry';
import { withProtected } from './withProtected';
import { withFeatureFlag } from './withFeatureFlag';

export const verification = [
	{
		path: '/verifications/',
		Component: withFeatureFlag(
			withProtected(lazy(() => import('../pages/Verifications'))),
			'verifications-enabled'
		),
		children: [
			{
				path: '/verifications/',
				Component: lazy(() => import('../pages/Verifications/List')),
				handle: {
					key: 'pages.verifications.title'
				}
			},
			{
				path: '/verifications/request',
				Component: lazy(() => import('../pages/Verifications/Request')),
				handle: {
					key: 'pages.verifications.request.title'
				}
			}
		]
	}
];
